export namespace KommunikationNotificationTypes {
    export const MITTEILUNG_NOTIFICATION = 'KOMMUNIKATION.MITTEILUNG';
    
}

